import { extendTheme } from '@blockanalitica/ui';
import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { colors } from './colors';
import { card } from './components/card';
import { heatmapCell } from './components/heatmapCell';
import { kpiFooter } from './components/kpiFooter';
import { kpiHeader } from './components/kpiHeader';
import { linkButton } from './components/linkButton';
import { table } from './components/table';
import { tableCell } from './components/tableCell';
import { headerCell } from './components/headerCell';
import { sortingButton } from './components/sortingButton';
import { kpiCardFooter } from './components/kpiCardFooter';
import { displaySwitch } from './components/displaySwitch';
import { displaySwitchOption } from './components/displaySwitchOption';
import { chartKpiSubValue } from './components/chartKpiSubValue';
import { chartKpiValue } from './components/chartKpiValue';
import { chartKpiLabel } from './components/chartKpiLabel';
import { paginationCurrentNavigation } from './components/paginationCurrentNavigation';
import { collapsableSidebar } from './components/collapsableSidebar';
import { kpiCardValue } from './components/kpiCardValue';
import { heading } from './components/heading';
import { fancyText } from './components/fancyText';
import { tooltipContent } from './components/tooltipContent';
import { input } from './components/input';

export const theme: Theme = extendTheme({
  charts: {
    minFontSize: 9,
    maxFontSize: 12
  },
  colors,
  components: [
    card,
    chartKpiSubValue,
    chartKpiValue,
    chartKpiLabel,
    collapsableSidebar,
    displaySwitch,
    displaySwitchOption,
    heatmapCell,
    kpiCardFooter,
    kpiFooter,
    kpiHeader,
    linkButton,
    paginationCurrentNavigation,
    table,
    tableCell,
    headerCell,
    sortingButton,
    heading,
    kpiCardValue,
    fancyText,
    tooltipContent,
    input
  ]
});
